import { Fetcher } from '../../Fetcher';

import type { StatsConfigType } from './types';

export interface FetchStatsConfigParams {
  url: string;
  ipAddress: string;
}

export const fetchStatsConfig = ({ url, ipAddress }: FetchStatsConfigParams): Promise<StatsConfigType> => {
  const timeout = 2000; // 2 seconds timeout
  const controller = new AbortController();
  const signal = controller.signal;
  // reject if the request takes more than 2 seconds
  const timerId = setTimeout(() => {
    controller.abort();
  }, timeout);
  return Fetcher.fetch<StatsConfigType>(url + '/quality/video/' + ipAddress, {
    logAs: '/quality/video/',
    signal,
  }).finally(() => {
    // clear the timer to prevent memory leaks
    clearTimeout(timerId);
  });
};
